import React, { useState, useEffect } from 'react';

const AddSubject = () => {

    const [subjectname, setSubjectName] = useState('');
    const [subjects, setSubjects] = useState([]);
    const [categories, setCategories] = useState([]);
    const [courseName, setCourseName] = useState('');

    const fetchCourses = async () => {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/course/courses`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        });

        const data = await res.json();
        setCategories(data);   // FIXED
    };

    const fetchSubjects = async () => {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/course/subject`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        });

        const data = await res.json();
        setSubjects(data);
    };

    useEffect(() => {
        fetchCourses();
        fetchSubjects();
    }, []);

    const handleAddCourse = async (event) => {
        event.preventDefault();

        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/course/subject`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            body: JSON.stringify({
                course_name: courseName,
                subjectname: subjectname
            })
        });

        if (res.ok) {
            alert("Subject Added Successfully");
            setSubjectName('');
            setCourseName('');
            fetchSubjects();
        } else {
            alert("Failed to add subject");
        }
    };

    return (
        <div className="container mt-5">
            <h2>Add Subject</h2>

            <form onSubmit={handleAddCourse}>   {/* FIXED */}
                <select
                    value={courseName}
                    onChange={(e) => setCourseName(e.target.value)}
                >
                    <option value="">Select Course</option>
                    {categories.map((cat) => (
                        <option key={cat.id} value={cat.course}>
                            {cat.course}
                        </option>
                    ))}
                </select>

                <input
                    type="text"
                    placeholder="Subject Name"
                    value={subjectname}
                    onChange={(e) => setSubjectName(e.target.value)}
                />

                <button type="submit">Add Subject</button>
            </form>

            <h3 className="mt-4">Subjects:</h3>
            <div>
                {subjects.map((subject) => (
                    <p key={subject.id}>
                        {subject.course_name} — {subject.subjectname}
                    </p>
                ))}
            </div>
        </div>
    );
};

export default AddSubject;
